module.exports = __webpack_public_path__ + "img/logo-ecfa.3fd54838.svg";